<div tabindex="0" class="diagnosis-prediction-card" *ngIf="data">
    <div *ngIf="predictionData?.image" class="diagnosis-prediction-card--image">
        <img [src]="predictionData.image.filename"/>
    </div>
    <div *ngIf="predictionData" class="diagnosis-prediction-card--content">
        <div class="diagnosis-prediction-card--content--header">
            {{data.title}}
        </div>
        <div class="diagnosis-prediction-card--content--description" [innerHTML]="data.description | storyblokRichtext">
        </div>
        <div class="diagnosis-prediction-card--content--name">
            {{predictionData?.title}}
        </div>
        <div class="diagnosis-prediction-card--content--description" [innerHTML]="data.advice | storyblokRichtext">
        </div>
        <a href="#" class="diagnosis-prediction-card--content--btn" [routerLink]="['/me/diagnosis-prediction/' + predictionData.slug]">
            <span>{{data.readMore}}</span>
            <i class="fas fa-arrow-right"></i>
        </a>
    </div>
</div>